import "./navbar.scss";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import FullscreenExitOutlinedIcon from "@mui/icons-material/FullscreenExitOutlined";
import ListOutlinedIcon from "@mui/icons-material/ListOutlined";
import { DarkModeContext } from "../../context/darkModeContext";
import { useContext } from "react";
import {AuthContext} from "../../context/AuthContext";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import {AirplaneTicket} from "@mui/icons-material";

const Navbar = () => {
  const { dispatch } = useContext(DarkModeContext);
  const { user } = useContext(AuthContext);

  return (
    <div className="navbar">
      <div className="wrapper">
        <div className="search">
          <AirplaneTicket/>
        </div>
        <div className="items">
          <div className="item">
            <DarkModeOutlinedIcon
                className="icon"
                onClick={() => dispatch({type: "TOGGLE"})}
            />
          </div>
          <div className="item">
            <FullscreenExitOutlinedIcon className="icon"/>
          </div>
          {/*<div className="item">*/}
          {/*  <NotificationsNoneOutlinedIcon className="icon"/>*/}
          {/*  <div className="counter">1</div>*/}
          {/*</div>*/}
          {/*<div className="item">*/}
          {/*  <ChatBubbleOutlineOutlinedIcon className="icon"/>*/}
          {/*  <div className="counter">2</div>*/}
          {/*</div>*/}
          <div className="item">
            {user.id}
          </div>
          <div className="item">
            <ListOutlinedIcon className="icon"/>
          </div>
          <div className="item">
            <img
                src="https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"
                alt=""
                className="avatar"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
